import { Call } from "@helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "@redux/actions/administrador/ui/ui";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    active: null,
    list: [],
    pagination: {
        data: [],
        per_page: 10,
        total: 0,
    },
};

export const IneValidations = createSlice({
    name: "IneValidations",
    initialState,
    reducers: {
        setActive: (state, action) => {
            state.active = action.payload;
        },
        clearActive: (state) => {
            state.active = initialState.active;
        },

        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        clearPagination: (state) => {
            state.pagination = initialState.pagination;
        },

        setList: (state, action) => {
            state.list = action.payload;
        },
        clearList: (state) => {
            state.list = initialState.list;
        },

        clearState: (state) => {
            state = initialState;
        },
    },
});

export const {
    setActive,
    clearActive,

    setPagination,
    clearPagination,

    setList,
    clearList,

    clearState,
} = IneValidations.actions;

export default IneValidations.reducer;

export const startShow = ({
    query = "",
    page = 1,
    number_rows = 25,
    list = false,
    exceptions = [],
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        if (query) params.set("q", query);
        if (page) params.set("page", page);
        if (number_rows) params.set("per_page", number_rows);
        if (Array.isArray(exceptions) && exceptions.length > 0) {
            exceptions.forEach((ex) => params.append("exceptions[]", ex));
        }
        params.set("list", list ? 1 : 0);

        const resp = await Call(
            "services/ine-validate/show",
            "GET",
            params.toString()
        );

        if (resp.success) {
            if (list) {
                dispatch(setList(resp.success));
            } else {
                dispatch(setPagination(resp.success));
            }
        }

        dispatch(stopUILoading());
    };
};
